import classNames from 'classnames';

import loadingSvg from '../../images/loading.svg';

import './Loading.scss';

// `decorative`: the spinner sits next to text that already says what is loading (and
// is announced on its own), so it adds no status of its own for screen readers.
const Loading = ({ size = 80, className, decorative = false }) => (
  <div
    className={classNames('Loading', className)}
    {...(decorative ?
      { 'aria-hidden': true } :
      { role: 'status', 'aria-live': 'polite', 'aria-label': 'Loading' })}
  >
    <img
      className="Loading__spinner"
      src={loadingSvg}
      width={size}
      height={size}
      alt=""
    />
  </div>
);

export default Loading;
